import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, AlertTriangle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-console-bg text-console-text font-geist flex items-center justify-center p-6 relative">
      {/* Faint 48px grid */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.025) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(ellipse at 50% 30%, black 30%, transparent 80%)',
          WebkitMaskImage: 'radial-gradient(ellipse at 50% 30%, black 30%, transparent 80%)',
        }}
      />

      <div className="relative z-10 text-center space-y-8 max-w-md">
        <div className="w-16 h-16 rounded-full bg-console-signal/15 border border-console-signal/30 flex items-center justify-center mx-auto">
          <AlertTriangle className="h-7 w-7 text-console-signal" />
        </div>

        <div className="space-y-3">
          <span className="font-geist-mono text-[11px] tracking-[0.2em] uppercase text-console-signal">Error · 404</span>
          <h1 className="font-geist text-[clamp(56px,10vw,96px)] font-semibold tracking-[-0.04em] leading-none text-console-text">404</h1>
          <h2 className="font-geist text-[20px] font-semibold tracking-tight text-console-text">Page not found</h2>
          <p className="font-geist text-[14px] text-console-muted leading-relaxed">
            The page you're looking for doesn't exist, or you don't have access to it.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate('/')}
            className="h-12 px-5 font-geist font-semibold text-[14px] bg-console-primary text-console-bg hover:bg-console-primary/90 rounded-[6px]"
          >
            <Home className="mr-2 h-4 w-4" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
